import { Layout, type LayoutProps } from "react-admin";

export const AdminLayout = (props: LayoutProps) => <Layout {...props} />;
